import Helper from "@ember/component/helper";
import { service } from "@ember/service";

export default class BandwidthFormat extends Helper {
  @service intl;

  compute([networkAdapter]) {
    const bandwidth = networkAdapter?.bandwidth;

    if (bandwidth == null || typeof bandwidth !== "number") return "";
    if (bandwidth >= 1000) {
      return this.intl.t("label.bandwidth-gbps", { bandwidth: bandwidth / 1000 });
    }
    return this.intl.t("label.bandwidth-mbps", { bandwidth });
  }
}
